import { TemplateCategory } from "./types";

export const trabalhistasCategory: TemplateCategory = {
  id: 'trabalhistas',
  name: 'Trabalhistas',
  emoji: '👷',
  description: 'Documentos de direito do trabalho',
  subcategories: [
    {
      id: 'acoes-trabalhistas',
      name: 'Ações Trabalhistas',
      emoji: '⚖️',
      templates: [
        {
          id: 'reclamacao-trabalhista',
          name: 'Reclamação trabalhista',
          type: 'Ação',
          description: 'Petição inicial trabalhista',
          icon: 'Scale',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO DA [VARA] VARA DO TRABALHO DE [CIDADE]

contra [NOME DA EMPRESA], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS
[RELATO DOS FATOS]

II - DO DIREITO
[FUNDAMENTAÇÃO JURÍDICA]

III - DOS PEDIDOS
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-horas-extras',
          name: 'Ação de horas extras',
          type: 'Ação',
          description: 'Cobrança de horas extras não pagas',
          icon: 'Clock',
          content: `AÇÃO DE COBRANÇA DE HORAS EXTRAS

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR], vem propor a presente ação contra [NOME DA EMPRESA]:

HISTÓRICO LABORAL:
- Período: [DATA INÍCIO] a [DATA FIM]
- Cargo: [CARGO]
- Salário: R$ [VALOR]
- Jornada contratual: [HORAS] horas

HORAS EXTRAS PRESTADAS:
[DETALHAMENTO DAS HORAS]

CÁLCULO DO DÉBITO:
[CÁLCULO DETALHADO]

PEDIDOS:
a) Pagamento das horas extras
b) Reflexos em férias, 13º salário e FGTS
c) Juros e correção monetária

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-rescisao-indireta',
          name: 'Ação de rescisão indireta',
          type: 'Ação',
          description: 'Rescisão por falta grave do empregador',
          icon: 'UserX',
          content: `AÇÃO DE RESCISÃO INDIRETA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação de rescisão indireta contra [NOME DA EMPRESA]:

MOTIVO DA RESCISÃO INDIRETA:
[DESCRIÇÃO DA FALTA GRAVE DO EMPREGADOR]

DIREITOS PLEITEADOS:
- Aviso prévio indenizado
- Férias vencidas e proporcionais
- 13º salário
- FGTS + 40%
- Seguro-desemprego
- Indenização por danos morais

PROVAS:
[RELAÇÃO DAS PROVAS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-acidente-trabalho',
          name: 'Ação de acidente de trabalho',
          type: 'Ação',
          description: 'Indenização por acidente laboral',
          icon: 'AlertTriangle',
          content: `AÇÃO DE INDENIZAÇÃO POR ACIDENTE DE TRABALHO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação indenizatória contra [NOME DA EMPRESA]:

DO ACIDENTE:
Data: [DATA]
Local: [LOCAL]
Circunstâncias: [DESCRIÇÃO]

DAS LESÕES:
[DESCRIÇÃO DAS LESÕES]

DA CULPA DO EMPREGADOR:
[FUNDAMENTAÇÃO DA CULPA]

DOS DANOS:
- Danos morais: R$ [VALOR]
- Danos materiais: R$ [VALOR]
- Lucros cessantes: R$ [VALOR]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-assedio-moral',
          name: 'Ação por assédio moral',
          type: 'Ação',
          description: 'Indenização por assédio moral no trabalho',
          icon: 'Shield',
          content: `AÇÃO DE INDENIZAÇÃO POR ASSÉDIO MORAL

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação contra [NOME DA EMPRESA]:

DO ASSÉDIO MORAL:
[DESCRIÇÃO DETALHADA DOS ATOS]

DOS DANOS CAUSADOS:
- Danos psicológicos
- Prejuízos profissionais
- Impactos na saúde

VALOR DA INDENIZAÇÃO:
Danos morais: R$ [VALOR]

PROVAS:
[RELAÇÃO DAS PROVAS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-equiparacao-salarial',
          name: 'Ação de equiparação salarial',
          type: 'Ação',
          description: 'Equiparação salarial entre colegas',
          icon: 'Equal',
          content: `AÇÃO DE EQUIPARAÇÃO SALARIAL

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação de equiparação salarial contra [NOME DA EMPRESA]:

FUNÇÃO DO AUTOR:
- Cargo: [CARGO]
- Salário: R$ [VALOR]
- Admissão: [DATA]

PARADIGMA:
- Nome: [NOME DO PARADIGMA]
- Salário: R$ [VALOR]
- Diferença: R$ [VALOR]

REQUISITOS ATENDIDOS:
- Mesma função
- Trabalho de igual valor
- Mesmo empregador
- Mesma localidade

PEDIDOS:
- Equiparação salarial
- Diferenças salariais
- Reflexos

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-estabilidade',
          name: 'Ação de reintegração por estabilidade',
          type: 'Ação',
          description: 'Reintegração de empregado estável',
          icon: 'UserCheck',
          content: `AÇÃO DE REINTEGRAÇÃO POR ESTABILIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação de reintegração contra [NOME DA EMPRESA]:

TIPO DE ESTABILIDADE:
( ) Acidentário
( ) Gestante
( ) Dirigente sindical
( ) CIPA
( ) Outro: [ESPECIFICAR]

PERÍODO DE ESTABILIDADE:
De [DATA] a [DATA]

DATA DA DISPENSA: [DATA]

PEDIDOS:
- Reintegração ao emprego
- Pagamento dos salários do período
- Benefícios do período

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-doenca-ocupacional',
          name: 'Ação de doença ocupacional',
          type: 'Ação',
          description: 'Indenização por doença do trabalho',
          icon: 'Activity',
          content: `AÇÃO DE INDENIZAÇÃO POR DOENÇA OCUPACIONAL

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação indenizatória contra [NOME DA EMPRESA]:

DA DOENÇA OCUPACIONAL:
Patologia: [NOME DA DOENÇA]
Nexo causal: [RELAÇÃO COM O TRABALHO]
CID: [CÓDIGO]

ATIVIDADE LABORAL:
Função: [CARGO]
Período: [DATA INÍCIO] a [DATA FIM]
Condições de trabalho: [DESCRIÇÃO]

DOS DANOS:
- Incapacidade: [GRAU]
- Danos morais: R$ [VALOR]
- Danos materiais: R$ [VALOR]
- Pensão mensal: R$ [VALOR]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-discriminacao',
          name: 'Ação por discriminação no trabalho',
          type: 'Ação',
          description: 'Indenização por discriminação laboral',
          icon: 'Users',
          content: `AÇÃO DE INDENIZAÇÃO POR DISCRIMINAÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação contra [NOME DA EMPRESA]:

TIPO DE DISCRIMINAÇÃO:
( ) Racial
( ) Sexual
( ) Idade
( ) Deficiência
( ) Religião
( ) Orientação sexual
( ) Outro: [ESPECIFICAR]

ATOS DISCRIMINATÓRIOS:
[DESCRIÇÃO DOS FATOS]

CONSEQUÊNCIAS:
[IMPACTOS SOFRIDOS]

VALOR DA INDENIZAÇÃO:
Danos morais: R$ [VALOR]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-adicional-periculosidade',
          name: 'Ação de adicional de periculosidade',
          type: 'Ação',
          description: 'Cobrança de adicional por atividade perigosa',
          icon: 'AlertTriangle',
          content: `AÇÃO DE ADICIONAL DE PERICULOSIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação contra [NOME DA EMPRESA]:

ATIVIDADE PERIGOSA:
Tipo: [DESCRIÇÃO DA ATIVIDADE]
Período: [DATA INÍCIO] a [DATA FIM]
Exposição: [DESCRIÇÃO DOS RISCOS]

BASE LEGAL:
NR-16 - Atividades e Operações Perigosas

VALOR DO ADICIONAL:
30% sobre o salário base

CÁLCULO:
- Período: [MESES] meses
- Salário base: R$ [VALOR]
- Adicional devido: R$ [VALOR]
- Reflexos: R$ [VALOR]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-adicional-insalubridade',
          name: 'Ação de adicional de insalubridade',
          type: 'Ação',
          description: 'Cobrança de adicional por insalubridade',
          icon: 'Shield',
          content: `AÇÃO DE ADICIONAL DE INSALUBRIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO AUTOR] vem propor ação contra [NOME DA EMPRESA]:

AGENTE INSALUBRE:
Tipo: [AGENTE NOCIVO]
Grau: [MÍNIMO/MÉDIO/MÁXIMO]
Período de exposição: [DATA INÍCIO] a [DATA FIM]

PERCENTUAL DO ADICIONAL:
( ) 10% - grau mínimo
( ) 20% - grau médio  
( ) 40% - grau máximo

BASE DE CÁLCULO:
Salário mínimo nacional

VALOR DEVIDO:
- Adicional mensal: R$ [VALOR]
- Período: [MESES] meses
- Total: R$ [VALOR]
- Reflexos: R$ [VALOR]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'recursos-trabalhistas',
      name: 'Recursos Trabalhistas',
      emoji: '📋',
      templates: [
        {
          id: 'recurso-ordinario-trabalhista',
          name: 'Recurso ordinário trabalhista',
          type: 'Recurso',
          description: 'Recurso ao TRT contra sentença',
          icon: 'Scale',
          content: `RECURSO ORDINÁRIO

EGRÉGIO TRIBUNAL REGIONAL DO TRABALHO DA [REGIÃO] REGIÃO

[NOME DO RECORRENTE] vem interpor RECURSO ORDINÁRIO contra a r. sentença proferida nos autos do processo nº [NÚMERO]:

I - DO JUÍZO DE ADMISSIBILIDADE
[REQUISITOS DE ADMISSIBILIDADE]

II - DO MÉRITO
[FUNDAMENTOS DO RECURSO]

III - DOS PEDIDOS
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'agravo-petitorio',
          name: 'Agravo de petição',
          type: 'Recurso',
          description: 'Recurso contra decisão em execução',
          icon: 'Gavel',
          content: `AGRAVO DE PETIÇÃO

EGRÉGIO TRIBUNAL REGIONAL DO TRABALHO

[NOME DO AGRAVANTE] vem interpor AGRAVO DE PETITION contra decisão proferida em execução:

DA DECISÃO AGRAVADA:
[RESUMO DA DECISÃO]

DOS FUNDAMENTOS:
[ARGUMENTAÇÃO]

DOS PEDIDOS:
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'recurso-revista',
          name: 'Recurso de revista',
          type: 'Recurso',
          description: 'Recurso ao TST',
          icon: 'Scale',
          content: `RECURSO DE REVISTA

COLENDO TRIBUNAL SUPERIOR DO TRABALHO

[NOME DO RECORRENTE] vem interpor RECURSO DE REVISTA contra acórdão do TRT:

I - DO JUÍZO DE ADMISSIBILIDADE
[REQUISITOS ESPECÍFICOS]

II - DA TRANSCENDÊNCIA
[DEMONSTRAÇÃO DA TRANSCENDÊNCIA]

III - DO MÉRITO
[VIOLAÇÃO/DIVERGÊNCIA]

IV - DOS PEDIDOS
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede conhecimento e provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'embargo-execucao',
          name: 'Embargos à execução',
          type: 'Embargos',
          description: 'Defesa na fase de execução',
          icon: 'Shield',
          content: `EMBARGOS À EXECUÇÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DO TRABALHO

[NOME DO EMBARGANTE] vem opor EMBARGOS À EXECUÇÃO:

MATÉRIAS ARGUIDAS:
( ) Excesso de execução
( ) Cumprimento da obrigação
( ) Prescrição
( ) Nulidade da execução
( ) Incompetência

FUNDAMENTAÇÃO:
[ARGUMENTAÇÃO ESPECÍFICA]

CÁLCULO CORRETO:
[DEMONSTRATIVO DE CÁLCULO]

Nestes termos, pede acolhimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'agravo-instrumento-trabalhista',
          name: 'Agravo de instrumento trabalhista',
          type: 'Recurso',
          description: 'Recurso contra decisão interlocutória',
          icon: 'FileText',
          content: `AGRAVO DE INSTRUMENTO

EGRÉGIO TRIBUNAL REGIONAL DO TRABALHO

[NOME DO AGRAVANTE] vem interpor AGRAVO DE INSTRUMENTO contra decisão interlocutória:

DA DECISÃO AGRAVADA:
Data: [DATA]
Teor: [RESUMO DA DECISÃO]

FUNDAMENTOS:
[ARGUMENTAÇÃO JURÍDICA]

PEDIDO DE EFEITO SUSPENSIVO:
[JUSTIFICATIVA]

DOS PEDIDOS:
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'contratos-trabalhistas',
      name: 'Contratos e Documentos',
      emoji: '📝',
      templates: [
        {
          id: 'contrato-trabalho',
          name: 'Contrato de trabalho',
          type: 'Contrato',
          description: 'Contrato individual de trabalho',
          icon: 'FileText',
          content: `CONTRATO INDIVIDUAL DE TRABALHO

EMPREGADOR: [NOME DA EMPRESA], [QUALIFICAÇÃO]
EMPREGADO: [NOME], [QUALIFICAÇÃO]

CLÁUSULAS:

1ª - FUNÇÃO: [CARGO/FUNÇÃO]
2ª - SALÁRIO: R$ [VALOR] mensais
3ª - JORNADA: [HORAS] horas semanais
4ª - LOCAL DE TRABALHO: [ENDEREÇO]
5ª - INÍCIO: [DATA]

DISPOSIÇÕES GERAIS:
[CLÁUSULAS ESPECÍFICAS]

[LOCAL], [DATA]

_________________________________     _________________________________
[NOME DA EMPRESA]                     [NOME DO EMPREGADO]
EMPREGADOR                            EMPREGADO`
        },
        {
          id: 'acordo-demissional',
          name: 'Acordo de rescisão',
          type: 'Acordo',
          description: 'Acordo para rescisão de contrato',
          icon: 'Handshake',
          content: `ACORDO DE RESCISÃO CONTRATUAL

EMPREGADOR: [NOME DA EMPRESA]
EMPREGADO: [NOME]

CONDIÇÕES:

1. Rescisão por comum acordo (Art. 484-A da CLT)
2. Pagamento de 50% do aviso prévio
3. Pagamento de 20% da multa do FGTS
4. Direito ao seguro-desemprego por metade do período

VALORES A SEREM PAGOS:
- Saldo de salário: R$ [VALOR]
- Férias proporcionais: R$ [VALOR]
- 13º proporcional: R$ [VALOR]
- 50% aviso prévio: R$ [VALOR]
- 20% FGTS: R$ [VALOR]

TOTAL: R$ [VALOR]

[LOCAL], [DATA]

_________________________________     _________________________________
[NOME DA EMPRESA]                     [NOME DO EMPREGADO]`
        },
        {
          id: 'termo-quitacao',
          name: 'Termo de quitação',
          type: 'Termo',
          description: 'Quitação geral de direitos trabalhistas',
          icon: 'CheckCircle',
          content: `TERMO DE QUITAÇÃO

Eu, [NOME DO EMPREGADO], declaro que recebi da empresa [NOME DA EMPRESA] todas as verbas rescisórias a que tinha direito, dando plena, geral e irrevogável quitação.

PERÍODO TRABALHADO: [DATA] a [DATA]
FUNÇÃO: [CARGO]

VALORES RECEBIDOS:
[DISCRIMINAÇÃO DOS VALORES]

TOTAL RECEBIDO: R$ [VALOR]

Nada mais tendo a reclamar a qualquer título.

[LOCAL], [DATA]

_________________________________
[NOME DO EMPREGADO]

TESTEMUNHAS:
1. [NOME]
2. [NOME]`
        },
        {
          id: 'advertencia-trabalhista',
          name: 'Advertência disciplinar',
          type: 'Advertência',
          description: 'Advertência por escrito ao empregado',
          icon: 'AlertCircle',
          content: `ADVERTÊNCIA POR ESCRITO

EMPREGADO: [NOME]
FUNÇÃO: [CARGO]
SETOR: [SETOR]

MOTIVO DA ADVERTÊNCIA:
[DESCRIÇÃO DETALHADA DA FALTA]

NORMA VIOLADA:
[ESPECIFICAR NORMA/REGULAMENTO]

ADVERTÊNCIA:
Fica o empregado advertido de que a reincidência poderá resultar em suspensão ou dispensa por justa causa.

[LOCAL], [DATA]

_________________________________
[NOME DO SUPERVISOR]
CARGO

CIENTE:
_________________________________
[NOME DO EMPREGADO]`
        },
        {
          id: 'suspensao-disciplinar',
          name: 'Suspensão disciplinar',
          type: 'Suspensão',
          description: 'Suspensão disciplinar de empregado',
          icon: 'Ban',
          content: `SUSPENSÃO DISCIPLINAR

EMPREGADO: [NOME]
FUNÇÃO: [CARGO]

MOTIVO DA SUSPENSÃO:
[DESCRIÇÃO DETALHADA]

PERÍODO DE SUSPENSÃO:
De [DATA] a [DATA] ([NÚMERO] dias)

BASE LEGAL: Art. 474 da CLT

ADVERTÊNCIA:
Nova reincidência poderá resultar em dispensa por justa causa.

[LOCAL], [DATA]

_________________________________
[NOME DO RESPONSÁVEL]
CARGO

CIENTE:
_________________________________
[NOME DO EMPREGADO]`
        },
        {
          id: 'atestado-trabalho',
          name: 'Atestado de trabalho',
          type: 'Atestado',
          description: 'Atestado de vínculo empregatício',
          icon: 'FileCheck',
          content: `ATESTADO DE TRABALHO

Atestamos que [NOME], portador do CPF nº [CPF], trabalha nesta empresa desde [DATA], exercendo a função de [CARGO], com remuneração mensal de R$ [VALOR].

Durante o período em que trabalha conosco, tem se portado com dedicação e responsabilidade.

O presente atestado é fornecido para os fins que se fizerem necessários.

[LOCAL], [DATA]

_________________________________
[NOME DA EMPRESA]
CNPJ: [CNPJ]`
        },
        {
          id: 'declaracao-renda',
          name: 'Declaração de renda',
          type: 'Declaração',
          description: 'Declaração de rendimentos do trabalhador',
          icon: 'DollarSign',
          content: `DECLARAÇÃO DE RENDIMENTOS

Declaramos que [NOME], CPF [CPF], é empregado desta empresa desde [DATA], exercendo a função de [CARGO].

RENDIMENTOS [ANO]:
- Salários: R$ [VALOR]
- 13º Salário: R$ [VALOR]
- Férias: R$ [VALOR]
- Outras verbas: R$ [VALOR]

TOTAL ANUAL: R$ [VALOR]

DESCONTOS:
- INSS: R$ [VALOR]
- IRRF: R$ [VALOR]

[LOCAL], [DATA]

_________________________________
[NOME DA EMPRESA]
CNPJ: [CNPJ]`
        },
        {
          id: 'regulamento-interno',
          name: 'Regulamento interno da empresa',
          type: 'Regulamento',
          description: 'Normas internas da empresa',
          icon: 'Book',
          content: `REGULAMENTO INTERNO

[NOME DA EMPRESA]

CAPÍTULO I - DISPOSIÇÕES GERAIS
Art. 1º - [FINALIDADE DO REGULAMENTO]

CAPÍTULO II - DOS HORÁRIOS
Art. 2º - [HORÁRIO DE TRABALHO]
Art. 3º - [INTERVALOS]

CAPÍTULO III - DOS DEVERES
Art. 4º - [DEVERES DOS EMPREGADOS]

CAPÍTULO IV - DAS PROIBIÇÕES
Art. 5º - [CONDUTAS PROIBIDAS]

CAPÍTULO V - DAS PENALIDADES
Art. 6º - [TIPOS DE PENALIDADE]

CAPÍTULO VI - DISPOSIÇÕES FINAIS
Art. 7º - [VIGÊNCIA]

[LOCAL], [DATA]

_________________________________
[NOME DA EMPRESA]`
        },
        {
          id: 'acordo-banco-horas',
          name: 'Acordo de banco de horas',
          type: 'Acordo',
          description: 'Compensação de jornada de trabalho',
          icon: 'Clock',
          content: `ACORDO DE BANCO DE HORAS

EMPRESA: [NOME DA EMPRESA]
EMPREGADO: [NOME]

CONDIÇÕES:

1. Período de compensação: [PERÍODO]
2. Limite de saldo: [HORAS] horas
3. Critério de compensação: [FORMA]
4. Controle: [SISTEMA DE CONTROLE]

CLÁUSULAS:
- As horas em débito deverão ser trabalhadas
- As horas em crédito poderão ser usufruídas como folga
- O saldo será zerado a cada [PERÍODO]

Por estarem de acordo, assinam:

[LOCAL], [DATA]

_________________________________     _________________________________
EMPRESA                               EMPREGADO`
        },
        {
          id: 'contrato-aprendiz',
          name: 'Contrato de aprendizagem',
          type: 'Contrato',
          description: 'Contrato especial para menor aprendiz',
          icon: 'GraduationCap',
          content: `CONTRATO DE APRENDIZAGEM

EMPREGADOR: [NOME DA EMPRESA]
APRENDIZ: [NOME], [IDADE] anos

CURSO: [NOME DO CURSO]
ENTIDADE FORMADORA: [INSTITUIÇÃO]

CONDIÇÕES:
- Duração: [PERÍODO] (máximo 2 anos)
- Jornada: [HORAS] horas (máximo 6h/dia)
- Salário: [VALOR] (mínimo salário mínimo/hora)
- Atividades teóricas: [HORAS]%
- Atividades práticas: [HORAS]%

OBRIGAÇÕES:
- Frequência ao curso: obrigatória
- Avaliação de desempenho: [CRITÉRIOS]

[LOCAL], [DATA]

_________________________________     _________________________________
EMPREGADOR                           APRENDIZ/RESPONSÁVEL`
        },
        {
          id: 'contrato-estagio',
          name: 'Termo de compromisso de estágio',
          type: 'Estágio',
          description: 'Contrato de estágio curricular',
          icon: 'BookOpen',
          content: `TERMO DE COMPROMISSO DE ESTÁGIO

CONCEDENTE: [NOME DA EMPRESA]
ESTAGIÁRIO: [NOME]
INSTITUIÇÃO DE ENSINO: [NOME]

CURSO: [NOME DO CURSO]
PERÍODO: [SEMESTRE/ANO]

CONDIÇÕES DO ESTÁGIO:
- Duração: [PERÍODO]
- Jornada: [HORAS] horas diárias
- Bolsa-auxílio: R$ [VALOR]
- Auxílio-transporte: R$ [VALOR]
- Seguro contra acidentes: [APÓLICE]

ATIVIDADES:
[DESCRIÇÃO DAS ATIVIDADES]

SUPERVISÃO:
Supervisor da empresa: [NOME]
Professor orientador: [NOME]

[LOCAL], [DATA]

_____________  _____________  _____________
CONCEDENTE     ESTAGIÁRIO     INST. ENSINO`
        },
        {
          id: 'aviso-previo',
          name: 'Aviso prévio',
          type: 'Aviso',
          description: 'Comunicação de rescisão contratual',
          icon: 'Calendar',
          content: `AVISO PRÉVIO

EMPREGADOR: [NOME DA EMPRESA]
EMPREGADO: [NOME]

Comunicamos que será rescindido o contrato de trabalho:

TIPO:
( ) Por iniciativa do empregador
( ) Por iniciativa do empregado

MODALIDADE:
( ) Trabalhado
( ) Indenizado

DATA DE SAÍDA: [DATA]

ÚLTIMO DIA DE TRABALHO: [DATA]

Durante o aviso prévio, ficam mantidos todos os direitos e deveres contratuais.

[LOCAL], [DATA]

_________________________________
[NOME DO RESPONSÁVEL]
EMPRESA

CIENTE:
_________________________________
[NOME DO EMPREGADO]`
        }
      ]
    }
  ]
};
